const SERVICES = [
  {
    icon: "ri-shield-check-line",
    title: "Statutory Website Audit",
    desc:
      "Comprehensive line-by-line review against FS 720.303, 718.111 and 719.104. Delivered as a shareable PDF your attorney and manager can act on.",
    features: ["Record retention map", "Missing-disclosure log", "Prioritized remediation plan"],
  },
  {
    icon: "ri-eye-line",
    title: "ADA / WCAG 2.2 Remediation",
    desc:
      "We rebuild your public-facing site to WCAG 2.2 AA, remediate legacy PDFs, and issue a signed Accessibility Conformance Report.",
    features: ["Automated + manual QA", "Screen-reader tested", "VPAT / ACR documentation"],
  },
  {
    icon: "ri-building-2-line",
    title: "Compliant Website Build",
    desc:
      "Purpose-built association websites with owner login, document library, board minutes, election voting hooks and violation portals.",
    features: ["Owner-only records vault", "Board meeting archive", "Multi-language ready"],
  },
  {
    icon: "ri-group-2-line",
    title: "HOPA 55+ Toolkit",
    desc:
      "Publish the policy statement, biennial occupancy survey, and age-verification workflow required to keep your 80/20 exemption.",
    features: ["Occupancy survey portal", "Age-verification intake", "HUD-ready records"],
  },
  {
    icon: "ri-server-line",
    title: "Managed Hosting and Monitoring",
    desc:
      "US-based, hurricane-hardened hosting with 24/7 uptime, daily backups, TLS, and a compliance monitor that flags stale disclosures.",
    features: ["99.99% uptime SLA", "Daily encrypted backups", "Statute-change alerts"],
  },
  {
    icon: "ri-file-shield-2-line",
    title: "Cyber and Privacy Compliance",
    desc:
      "Owner data handling, Florida Information Protection Act (FIPA) alignment, and cookie / privacy notice templates written for associations.",
    features: ["FIPA-aligned policies", "Breach response plan", "Cookie and consent banner"],
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32 bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-primary-700 font-semibold">
              <i className="ri-briefcase-4-line" />
              What we do
            </span>
            <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-foreground-950 leading-[1.05]">
              One partner. Every South Florida website compliance need.
            </h2>
          </div>
          <p className="max-w-md text-foreground-700 text-base leading-relaxed">
            From a statute audit to a full rebuild with owner logins - we scope every engagement to your community's size, budget and risk profile
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, idx) => (
            <article
              key={s.title}
              className={`group relative rounded-lg border p-8 transition-all hover:-translate-y-1 ${
                idx === 1
                  ? "bg-accent-500 border-accent-500 text-background-50"
                  : "bg-background-50 border-background-200 text-foreground-950"
              }`}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-md ${
                  idx === 1
                    ? "bg-background-50/15 border border-background-50/25"
                    : "bg-primary-50 border border-primary-100"
                }`}
              >
                <i
                  className={`${s.icon} text-2xl ${
                    idx === 1 ? "text-background-50" : "text-primary-700"
                  }`}
                />
              </div>
              <h3
                className={`mt-6 font-heading text-2xl font-semibold ${
                  idx === 1 ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {s.title}
              </h3>
              <p
                className={`mt-3 text-sm leading-relaxed ${
                  idx === 1 ? "text-background-100" : "text-foreground-700"
                }`}
              >
                {s.desc}
              </p>
              <ul
                className={`mt-6 space-y-2 pt-6 border-t ${
                  idx === 1 ? "border-background-50/20" : "border-background-200"
                }`}
              >
                {s.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm">
                    <i
                      className={`ri-check-line mt-0.5 ${
                        idx === 1 ? "text-accent-100" : "text-primary-600"
                      }`}
                    />
                    <span className={idx === 1 ? "text-background-50" : "text-foreground-800"}>
                      {f}
                    </span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}